import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import InlineCKEditor from '../common/editor/inline-editor';
import { getStorePerformances } from '../../actions/store-performance';
import { loadPageContent } from '../../actions/content';
import RetailerPerformance from './retailer-performance';

class StorePerformance extends Component {

  constructor(props) {
    super(props);

    this.pageSlug = 'store-performance';
  }

  componentDidMount() {
    const { dispatch, current_user } = this.props;

    dispatch(getStorePerformances());

    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  isLoading() {
    return this.props.loading;
  }

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  render() {
    return (
      <Grid bsClass="container">
        <Row>
          <Col lg={12}>
            <PageTitle>Sales Incentive</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]}/>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {this.isLoading() && 'Loading...'}
            {!this.isLoading() && <RetailerPerformance />}
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.stores.fetching && !state.stores.fetched,
    contents: state.content.list,
    current_user: state.viewConfig.profile,
    incentivePerformancesLoading: !state.incentivePerformances.fetched,
  };
};

export default connect(mapStateToProps)(StorePerformance);



// WEBPACK FOOTER //
// ./src/components/store-performance/index.jsx